import { createFileRoute } from "@tanstack/react-router";
import { query } from "areas/welcome/data";

import Welcome from "areas/welcome/pages/Welcome";
import { useStoreWelcome } from "areas/welcome/store";


export const Route = createFileRoute("/welcome/$partnerId")({
	component: () => <Welcome />,
	loader: async ({ context, params }) => {
		const { queryClient } = context;
		const config = await queryClient.ensureQueryData(query.config(params.partnerId));
		const welcome = useStoreWelcome.getState();
		if (config.step != welcome.step) welcome.setStep(config.step);
	},
	staticData: {
		footer: true
	}
});